import type { DataTableRowData } from '../../row-data-types.js';
import type { DataTableOptions } from '../types/table.types.js';
import type { DataTableLoadingStateProps } from './loading-state-types.js';

/** Progress circle height breakpoint (px). */
export const PROGRESS_CIRCLE_HEIGHT_BREAKPOINT = 120;

/**
 * Configuration hook for the DataTable LoadingState feature.
 * @internal
 */
export function useLoadingState<TData extends DataTableRowData>(
  props: DataTableLoadingStateProps,
  options: DataTableOptions<Exclude<TData, unknown>>,
): void {
  options.state = {
    ...options.state,
    loading: props.loading,
  };
}
